import React from "react";

import { useGetCareersMedia } from "../../../../hooks/misc";

import AudioPlayer from "../../AudioPlayer";
import VideoPlayer from "../../VideoPlayer";
import Loader from "../../../reusables/Loader";
import ResultGaugeChart from "../../../reusables/results/ResultGaugeChart";
import SkeletonLoader from "../../../reusables/SkeletonLoader";
import { SVGIcon } from "../../../wrappers/SVGIcon";

import { IInterviewQuestion } from "../../../../interfaces/services";

import { Icons } from "../../../../data/Assets";

interface IQuestionScoreCardProps {
    studentId: number;
    mediaId: number;
    score: number;
    question: IInterviewQuestion;
    totalQuestions: number;
    interviewTitle: string;
    interviewMode: string;
    onNextQuestion: () => void;
    onPreviousQuestion: () => void;
}

const QuestionScoreCard = (props: IQuestionScoreCardProps) => {
    const { studentId, mediaId, score, question, totalQuestions, interviewTitle, interviewMode, onNextQuestion, onPreviousQuestion } = props;

    const { data: media, isLoading: isMediaLoading } = useGetCareersMedia(studentId, mediaId);

    if (isMediaLoading) {
        return <Loader type={"full"} text={"Loading..."} />;
    }

    return (
        <div className="immersion__my_interviews__result__content__question_card">
            <div className="immersion__my_interviews__result__content__question_card__header">
                <ResultGaugeChart score={score} />
            </div>
            <div className='immersion__my_interviews__result__content__question_card__body'>
                <div className='immersion__my_interviews__result__content__question_card__question_number'>
                    <h6 className='immersion__my_interviews__result__content__question_card__question_number__text'>
                        {question.order} of {totalQuestions}
                    </h6>
                </div>

                <h5 className='immersion__my_interviews__result__content__question_card__question_text'>
                    {question.question}
                </h5>

                <div className='immersion__my_interviews__result__content__question_card__interview_info'>
                    <h6 className='immersion__my_interviews__result__content__question_card__interview_info__title_text'>
                        {interviewTitle}
                    </h6>
                    {/* <h6 className='immersion__my_interviews__result__content__question_card__interview_info__text'>
                        {moment.utc(interview.created_at).format('MMM DD YYYY')}
                    </h6> */}
                </div>

                {isMediaLoading &&
                    <Loader type={'normal'} text={'Loading answer...'} />
                }

                {/* {media && */}
                <div className='immersion__my_interviews__result__content__question_card__answer_container'>
                    {media ?
                        interviewMode === 'video'
                            ? <VideoPlayer
                                src={media?.url ?? ''}
                            />
                            : <div className='immersion__my_interviews__result__content__question_card__answer_container__audio_player'>
                                <AudioPlayer
                                    src={media?.url ?? ''}
                                />
                            </div>
                        : <SkeletonLoader type='image' />
                    }
                </div>
                {/* } */}

                <div className='immersion__my_interviews__result__content__question_card__buttons'>
                    <button
                        className='immersion__btn immersion__my_interviews__result__content__question_card__buttons__button'
                        onClick={() => onPreviousQuestion()}
                    >
                        <SVGIcon src={Icons.Chevron} rotation={90} color='primary' />
                    </button>
                    <button
                        className='immersion__btn immersion__my_interviews__result__content__question_card__buttons__button'
                        onClick={() => onNextQuestion()}
                    >
                        <SVGIcon src={Icons.Chevron} rotation={270} color='primary' />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuestionScoreCard;